import { useMemo } from 'react';
import { Box, Flex, Paragraph, Button } from 'theme-ui';

import { Link } from '@snippets';
import { useProductContext } from '../../../ProductContext';

import { themed } from './SizeOptions.theme';

export const SizeOptions = themed(({ theme, product }) => {
  const { setInitialProductHandle } = useProductContext();
  const options = product?.toggles?.size;

  const selectedSize = useMemo(
    () => product?.title?.split('|')[2]?.trim() || null,
    [product?.id]
  );

  return options?.length ? (
    <Box data-comp={SizeOptions.displayName} sx={theme.option}>
      <Flex sx={theme.header}>
        <Paragraph sx={theme.name}>Size</Paragraph>
        <Paragraph sx={theme.size}>{selectedSize}</Paragraph>
      </Flex>

      <Flex as="ul" sx={theme.values}>
        {options.map(({ title, handle, url }) => {
          const isSelected = product.handle === handle;
          return (
            <Box as="li" key={handle}>
              <Button
                variant="buttons.plain"
                onClick={() => setInitialProductHandle(handle)}
                sx={{
                  ...theme.value,
                  ...(isSelected
                    ? theme.value.available.selected
                    : theme.value.available.unselected),
                }}
              >
                {title}
              </Button>
            </Box>
          );
        })}
      </Flex>
    </Box>
  ) : null;
});

SizeOptions.displayName = 'SizeOptions';
